<script setup>
import { isEmpty, cloneDeep, sortBy } from 'lodash';
import {
  ref, inject,
} from 'vue';
import apiMaestrosLomloe from '@/api/cifra/lomloe/maestros';
import Spinner from '@/components/Spinner.vue';
import ModalSimple from '@/components/ModalSimple.vue';

const $I18n = inject('I18n');

const showModal = ref(false);
const competenciaActual = ref({});
const titulo = ref(null);
const mainForm = ref(null);
const cargando = ref(false);
const infoDescriptores = ref([]);
const descriptoresMarcados = ref([]);

const emits = defineEmits(['editar']);

function byOrden(array) {
  if (isEmpty(array)) { return []; }

  return sortBy(array, (o) => o.orden);
}

async function cargarDescriptores(cursoId) {
  cargando.value = true;
  try {
    const infoCursoData = (await apiMaestrosLomloe.infoCurso(cursoId)).data;
    infoDescriptores.value = byOrden(
      infoCursoData.info_curso.competencias_clave.find(
        (cc) => cc.id === competenciaActual.value.competencia_clave_definicion.id,
      ).descriptor_operativo_definiciones,
    );
  } finally {
    cargando.value = false;
  }
}

function show(competenciaClave, opciones = {}) {
  competenciaActual.value = cloneDeep(competenciaClave);
  titulo.value = opciones.titulo || $I18n.t('lomloe_descriptores_operativos_seleccionar');
  showModal.value = true;

  descriptoresMarcados.value = competenciaActual.value.descriptores.filter(
    (desc) => !desc._destroy,
  ).map(
    (desc) => desc.descriptor_operativo_definicion,
  );

  cargarDescriptores(competenciaClave.competencia_clave_definicion.curso_id);
}

function cerrarModal() {
  showModal.value = false;
}

defineExpose({ show, cerrarModal });

function isDescriptorSeleccionado(descriptor) {
  return descriptoresMarcados.value.some((desc) => desc.id === descriptor.id);
}

function toggleDescriptor(descriptor) {
  if (isDescriptorSeleccionado(descriptor)) {
    descriptoresMarcados.value.splice(
      descriptoresMarcados.value.findIndex((dm) => dm.id === descriptor.id), 1,
    );
  } else {
    descriptoresMarcados.value.push(descriptor);
  }
}

function competencia() {
  // Marcar los que se han borrado
  competenciaActual.value.descriptores.forEach((existente) => {
    const aunExiste = descriptoresMarcados.value.find(
      (desc) => desc.id === existente.descriptor_operativo_definicion.id,
    );
    if (!aunExiste) {
      if (existente.situacion_aprendizaje_competencia_clave_id !== null) {
        existente._destroy = true;
      }
    }
  });

  // Añadir los nuevos
  descriptoresMarcados.value.forEach((nuevo) => {
    const existe = competenciaActual.value.descriptores.find(
      (desc) => desc.descriptor_operativo_definicion.id === nuevo.id,
    );
    if (!existe) {
      competenciaActual.value.descriptores.push({
        descriptor_operativo_definicion_id: nuevo.id,
        descriptor_operativo_definicion: nuevo,
      });
    } else if (existe._destroy) {
      delete existe._destroy;
    }
  });

  return competenciaActual.value;
}
</script>
<template>
  <ModalSimple
    v-model="showModal"
    :titulo="titulo"
  >
    <div ref="mainForm">
      <Spinner v-if="cargando" :label="$t('cargando_informacion')" />
      <Transition enter-active-class="animated fadeInRight" mode="out-in">
        <div v-if="!cargando" class="descriptores-wrapper">
          <div v-if="!isEmpty(infoDescriptores)">
            <div class="m-t">
              <h5>{{ $t('lomloe_descriptores_operativos_seleccione') }}</h5>
            </div>
            <ul class="list-group clear-list m-t">
              <li
                v-for="descriptor in infoDescriptores"
                :key="descriptor.id"
                class="list-group-item"
              >
                <div class="pretty_checkbox">
                  <div class="pretty p-icon">
                    <input
                      class="pretty_checkbox"
                      type="checkbox"
                      :checked="isDescriptorSeleccionado(descriptor)"
                      @click="toggleDescriptor(descriptor)"
                    >
                    <div class="state p-cifra">
                      <i class="icon fa fa-check"></i>
                      <label class="pretty_checkbox control-label"></label>
                    </div>
                  </div>
                  {{ descriptor.codigo }} - {{ descriptor.nombre }}
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="m-t">
            {{ $t('lomloe_descriptores_operativos_no_hay') }}
          </div>
          <div class="form-actions m-t">
            <button
              class="btn btn-default"
              type="button"
              @click="cerrarModal"
              v-text="$t('Cancelar')"
            />
            <button
              type="button"
              class="btn btn-cifra"
              :disabled="isEmpty(descriptoresMarcados)"
              @click="emits('editar', competencia())"
            >
              <i class="fa fa-save"></i> {{ $t('Guardar') }}
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </ModalSimple>
</template>
